import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Components
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

type PropsType = {
  className?: string
}

function CameraOff(props: PropsType) {
  const { className } = props

  const { t } = useTranslation()

  return (
    <div className={cx('camera-off', className)}>
      <div className={cx('camera-off-icon')}>
        <Icon.CameraOff />
      </div>
      <p className={cx('camera-off-text')}>{t('LiveRoom_Camera_Off')}</p>
    </div>
  )
}

export default CameraOff
